import DreamRateStatus from "./dream-rate-status"
import CopyTextButton from "../../../../copy-text-button"
import Tooltip from "../../../../tool-tip"
import {
  LOAN_TYPE_OPTIONS_WITH_NONQM,
  PENDING_SUBSCRIPTION_STATUS_OPTIONS
} from "../../../../../constants"
import { PendingSubscriptionFull } from "../../../../../../types"
import Badge from "../../../../badge"
import InitialsAvatar from "../../../../initials-avatar"
import PricingStatusBadge from "../../../../pricing-status-badge"
import { getPendingSubscriptionStatus } from "../../../../../utils/dream-rate"

const getDisplayName = (firstName?: string | null, lastName?: string | null) =>
  firstName || lastName ? `${firstName} ${lastName}` : "Unnamed"

const getInitialsFromName = (name: string) =>
  name
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()

type Props = {
  info: PendingSubscriptionFull
  onClick: (row: PendingSubscriptionFull) => void
}

const EngagementsCell = ({ info, onClick }: Props) => {
  const {
    email,
    first_name,
    last_name,
    quote_info: { loan_type }
  } = info

  const status = getPendingSubscriptionStatus(info)
  const selectedStatusOption = PENDING_SUBSCRIPTION_STATUS_OPTIONS.find(
    so => so.id === status
  )

  const name = getDisplayName(first_name, last_name)
  const initials = getInitialsFromName(name)

  const loanTypeLabel = LOAN_TYPE_OPTIONS_WITH_NONQM.find(
    lto => lto.id === loan_type
  )?.name

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer" colSpan={2}>
      <div className="flex items-start gap-4">
        <InitialsAvatar initials={initials} size={12} />
        <div>
          <div className="flex items-center">
            <div
              className="font-bold mr-2 hover:border-b border-neutral-500 leading-none"
              onClick={() => onClick(info)}
            >
              {name}
            </div>
            <Tooltip
              toolTipNode={<DreamRateStatus status={status} />}
              placement="top"
              text={selectedStatusOption?.tooltipText ?? ""}
            />
          </div>
          <div className="flex items-center mt-2">
            <div className="text-neutral-400 text-sm">{email}</div>
            <CopyTextButton text={email} ariaLabel="Copy email" />
          </div>
          <div className="flex items-center gap-2 mt-2">
            <Badge.Alt className="px-3">
              Dream Rate: {info.trigger_rate}%
            </Badge.Alt>
            <Badge.Disabled className="px-3">{loanTypeLabel}</Badge.Disabled>
            <PricingStatusBadge
              className="px-3"
              pricingStatus={info.status === 9 ? 1 : 0}
            />
          </div>
        </div>
      </div>
    </td>
  )
}

export default EngagementsCell
